<template>
  <div class="comment-section">
    <div class="header">
      <div class="title">{{ $t('student_modal.detail_notvalidated_comment.title') }}</div>
      <div class="sub-title">{{ $t('student_modal.detail_notvalidated_comment.subtitle', { firstname: shortName }) }}</div>
    </div>
    <div class="content">
      <div class="sp-input comment-container input-container floating-label">
        <textarea-autosize
          id="comment"
          ref="studentComment"
          v-model="comment"
          type="text"
          class="floating-input"
          placeholder=" "
          :min-height="200"
          autofocus
          :maxlength="maxCharacters"
        />
        <label for="comment">Commentaire privé pour {{ $brand.label }}</label>
        <div ref="counter" class="input-container-counter">{{ charactersRemaining }} / {{ maxCharacters }}</div>
      </div>
      <div class="next-button" @click="saveComment">
        <span>Envoyer</span>
        <IconArrowRight />
      </div>
    </div>
  </div>
</template>

<script>

import IconArrowRight from '@/assets/icons/arrow-right.svg?component';

export default {
  name: 'StudentCommentModal',
  components: { IconArrowRight },
  props: ['shortName'],
  data() {
    return {
      maxCharacters: 300,
      minCharacters: 1,
      comment: null,
    };
  },
  computed: {
    charactersRemaining() {
      if (this.comment) {
        if (this.maxCharacters - this.comment.length <= 2) {
          this.$refs.counter.classList.add('red');
        } else {
          this.$refs.counter.classList.remove('red');
        }
        return this.maxCharacters - this.comment.length;
      }
      return this.maxCharacters;
    },
  },
  methods: {
    saveComment() {
      if (this.comment && this.comment.length >= this.minCharacters) {
        this.$mixpanel.track('Comment Student', { From: 'From Student Board' });
        this.$emit('save-comment', this.comment.trim());
      } else {
        this.$notify.error({
          title: this.$t('toast_message.notation.register_comment_to_student_obligatory_bad_score.title'),
          duration: 4000,
          message: this.$t('toast_message.notation.register_comment_to_student_obligatory_bad_score.text'),
        });
      }
    },
  },

};
</script>

<style scoped>

</style>
